import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { CustomerService } from 'src/app/shared/services/customer.service';

@UntilDestroy()
@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html',
  styleUrl: './customers-list.component.scss'
})
export class CustomersListComponent implements OnInit{

  allCustomers:any;
  filteredCustomers:any;
  searchCustomers: FormGroup;
  searchCtrl = new UntypedFormControl();
  selectedId=null;
  isCustomerGroup:boolean=false;
  constructor(public dialogRef: MatDialogRef<CustomersListComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: {customersList:any[],customerId:any,customerGroup?:boolean},
    private customerService:CustomerService,
    private translationService:TranslateService,
    private fb: FormBuilder,
  ){
    // debugger
this.allCustomers=data.customersList;
this.filteredCustomers=this.allCustomers;
this.selectedId=data.customerId;
this.isCustomerGroup=data.customerGroup?data.customerGroup:false;
  }

  ngOnInit() {
    this.searchCustomers = this.fb.group({
      selectedValue:[this.selectedId?this.filteredCustomers.find(cust=>cust.id==this.selectedId):null,Validators.required]
    })

    
this.searchCtrl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((value) => this.onFilterChange(value));
  }

  shouldDisable(customer: any): boolean {
   if(this.isCustomerGroup){
    return (customer.customerGroupId !=null && customer.customerGroupId>0)
   }
   return false
  }

  onFilterChange(value: string) {  
    // Ensure `allCustomers` is available
    if (!this.allCustomers || this.allCustomers.length === 0) {
      this.filteredCustomers = [];
      return;
    }
  
    // Clean and validate input
    value = value?.trim().toLowerCase(); 
  
    // If input is empty, reset to show all customers
    if (!value) {
      this.filteredCustomers = [...this.allCustomers];
      return;
    }
  
    // Filter by both Name and Code (case-insensitive, alphanumeric support)
    this.filteredCustomers = this.allCustomers.filter((customer: any) => {
      //// // debugger;
      const name = customer?.name.toLowerCase() || '';
      const code = customer?.code || '';
  
      return name.includes(value) || code.includes(value);
    });
  }
  get sortedCustomers() {
    return this.filteredCustomers.sort((a, b) => a.code.localeCompare(b.code));
  }
  onSubmit(){
    // // debugger;
    console.log(this.searchCustomers.value.selectedValue);
    if(this.searchCustomers.invalid){
      return;
    }
    this.dialogRef.close(this.searchCustomers.value.selectedValue);

  }
  onCancel(): void {
    this.dialogRef.close();
  }
}
